module.exports = __webpack_public_path__ + "static/pinterest-template-59c3fb7a37e267880377b3e0bfeed726.png";